
<b-card no-body>
  <b-card-header header-bg-variant="info" header-text-variant="white"> <span class="font-weight-bold">Selection Summary</span></b-card-header>
  <b-card-body class="p-0" style="max-height: 400px;overflow-y: auto">
    <b-list-group v-for="category_object in selected_nodes_by_category_name" :key="category_object.id">
      <b-list-group-item>
        <b-badge variant="info" class="mx-3">{{category_object.category_node.name}}</b-badge>
      </b-list-group-item>
      <b-list-group-item v-for="node in category_object.nodes" :key="node.id"
                         class="px-3 py-1 d-flex justify-content-between">
        <span>{{node.name}}</span>
        <span>
          <b-badge v-if="getNodePrice(node) !== 0">{{formatCurrency(getNodePrice(node))}}</b-badge>
        </span>
      </b-list-group-item>
    </b-list-group>

  </b-card-body>
</b-card>
